import React, { useEffect, useContext, useState } from 'react'
import styled from 'styled-components'
import TripsContext from '../../contexts/TripsContext'
import VehicleCard from '../VehicleCard'
import { useReverseGeocode } from '../../hooks/useReverseGeocode'
import { buildReverseGeocodeId } from '../../api/google-integration'
import { createVehicleInfoWindow } from '../../infowindow-utils'
import { getCarStatusIcon } from '../../utils'

type IProps = {
    vehicles: any[]
}

const VehiclesList = ({ vehicles = [] }: IProps): JSX.Element => {
    const {
        vehicleActive,
        hardwareData = {},
        reverseGeocoding,
        setCenterMap,
        setVehicleActive,
        setCurrentVehicleActive,
        selectedVehicles,
        setSelectedVehicles,
        markerHashMap,
        setInfoWindow,
        mapRef
    } = useContext(TripsContext)

    const { fillGoogleReverseGeocodeAux } = useReverseGeocode()
    const [reverseGeocodeWasCalculated, setReverseGeocodeWasCalculated] = useState(false)
    const [showDropdownId, setShowDropdownId] = useState<number>()
    const [firstHW, setFirstHW] = useState<any>()

    useEffect(() => {
        const calcGeocode = async () => {
            if (vehicles.length > 0 && reverseGeocodeWasCalculated === false) {
                await fillGoogleReverseGeocodeAux(vehicles, hardwareData)
                setFirstHW(hardwareData)
                setReverseGeocodeWasCalculated(true)
            }
        }

        calcGeocode()
    }, [hardwareData, vehicles])

    useEffect(() => {
        setFirstHW(hardwareData)
    }, [reverseGeocoding]);

    useEffect(() => {
        console.log(vehicleActive)
    }, [vehicleActive])

    const handleActiveClick = vehicle => {
        const data = hardwareData[vehicle?.imei]

        if (!data) return

        console.log(vehicle?.imei)

        if (selectedVehicles?.length > 0) {
            const ele: any = selectedVehicles[0]
            if (ele.imei === vehicle.imei) {
                const marker = markerHashMap.get(ele.imei)
                marker?.marker.setMap(null)
            }

            selectedVehicles.splice(0, selectedVehicles.length)
        } else {
            selectedVehicles.push(vehicle)
        }

        const hasVehicle = vehicleActive == vehicle.imei

        if (hasVehicle) {
            // const index = vehicleActive?.findIndex(ele => ele === vehicle.imei)
            setVehicleActive(undefined)
            setInfoWindow(undefined)
            setCurrentVehicleActive(undefined)
        } else {
            setCurrentVehicleActive(vehicle)
            setVehicleActive(vehicle.imei)

        }
    }

    const getAddress = vehicle => {
        const { lat, lng } = hardwareData[vehicle?.imei] || {}
        let key = buildReverseGeocodeId(lat, lng)
        let address = reverseGeocoding[key]?.address
        if (!address && firstHW) {
            const { lat, lng } = firstHW[vehicle?.imei] || {}
            key = buildReverseGeocodeId(lat, lng)
            address = reverseGeocoding[key]?.address
        }
        return address
    }

    return (
        <>
            <StyledVehicles>
                <div style={{ paddingBottom: 16 }}>
                    {vehicles?.map(vehicle => (
                        <VehicleCard
                            key={vehicle.imei}
                            isActive={vehicleActive == vehicle.imei}
                            onClick={() => handleActiveClick(vehicle)}
                            vehicle={vehicle}
                            hardwareData={hardwareData[vehicle?.imei]}
                            address={getAddress(vehicle)}
                            showDropdownId={showDropdownId}
                            setShowDropdownId={setShowDropdownId}
                        />
                    ))}
                </div>
            </StyledVehicles>
        </>
    )
}

export default React.memo(VehiclesList)

const StyledVehicles = styled.div`
    flex: 1;
`
